import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Loader from '../loader';
import { FONT_FAMILY_MAIN } from '../../theme';

const MainButton = styled.button`
  cursor: pointer;
  ${(props) => props.small
    ? `
    height: 28px;
    padding: 0 11px;
    font-size: 12px;
    border-radius: 5px;
  `
    : ` 
    height: 48px;
    padding: 0 24px;
    font-size: 16px;
    border-radius: 4px;
  `}
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  transition: all 0.3s;
  border: 1px solid;
  font-family: ${({ theme }) => (theme?.fontFamily ? theme.fontFamily : FONT_FAMILY_MAIN)};
  &:hover {
    opacity: 0.9;
  }
  ${(props) => props.block
    && `
    width: 100%;
  `}
  ${(props) => {
    if (props.disabled && props.outlined) {
      return `
        background-color: #ffffff;
        border-color: #d7dadc;
        color: #ccd0d4;
        &:hover {
          opacity: 1;
          cursor: not-allowed;
        }
      `;
    }

    if (props.disabled && !props.outlined) {
      return `
        background-color: #d7dadc;
        border-color: #d7dadc;
        color: #9aa1a9;
        &:hover {
          opacity: 1;
          cursor: not-allowed;
        }
      `;
    }

    if (props.outlined) {
      return `
        background-color: #ffffff;
        border-color: ${props.color};
        color: ${props.color};
      `;
    }

    return `
      background-color: ${props.color};
      border-color: ${props.color};
      color: ${props.textColor}; 
    `;
  }};
`;

class Btn extends Component {
  render() {
    const {
      text,
      name,
      block,
      small,
      type,
      outlined,
      color,
      textColor,
      disabled,
      tabIndex,
      isLoading,
      onClick,
      className,
    } = this.props;
    const spinnerColor = outlined ? color : '#ffffff';

    return (
      <MainButton
        type={type}
        tabIndex={tabIndex}
        block={block}
        small={small}
        color={color}
        textColor={textColor}
        disabled={disabled}
        outlined={outlined}
        onClick={isLoading ? () => {} : onClick}
        data-test-selector={`button-${name}`}
        className={className}
      >
        {isLoading ? (
          <Loader
            width={small ? 18 : 47}
            height={small ? 18 : 47}
            size={0.7}
            color={spinnerColor}
          />
        ) : (
          text
        )}
      </MainButton>
    );
  }
}

Btn.propTypes = {
  type: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  block: PropTypes.bool,
  small: PropTypes.bool,
  outlined: PropTypes.bool,
  color: PropTypes.string,
  textColor: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Btn.defaultProps = {
  type: '',
  text: 'Button',
  name: '',
  block: false,
  small: false,
  outlined: false,
  color: '#4a90e2',
  textColor: '#fff',
  disabled: false,
  tabIndex: null,
  isLoading: false,
  onClick: () => {},
  className: '',
};

export default Btn;
